<template>
  <div>
    <a-row :gutter="30" style="padding-top:30px;">
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">上传时间</a-col>
          <a-col span="18">
            <a-range-picker
              style="display:block;width:100%;"
              format="YYYY-MM-DD"
              v-model="params.uploadTime"
              @change="handleSelectPicker"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">职能</a-col>
          <a-col span="18">
            <a-cascader
              :options="jobs"
              v-model="params.job"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              changeOnSelect
              style="display:block"
              placeholder="请选择职能"
              @click="getJobData"
            >
              <a-icon slot="suffixIcon" :type="jobs ? 'down' : 'loading'" />
            </a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">学历要求</a-col>
          <a-col span="18">
            <a-select
              style="display:block"
              v-model="params.education_id"
              placeholder="请选择"
            >
              <template v-for="(item, index) in config.education">
                <a-select-option :key="index">{{ item }}</a-select-option>
              </template>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-input-group compact>
          <a-select style="width:35%" v-model="params.main">
            <a-select-option value="resume_name">候选人姓名</a-select-option>
            <a-select-option value="resume_mobile">候选人手机</a-select-option>
            <a-select-option value="resume_email">候选人邮箱</a-select-option>
            <!--<a-select-option value="id">简历ID</a-select-option>-->
          </a-select>
          <a-input
            style="width:65%"
            placeholder="请输入关键字"
            v-model="params.mainValue"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">所在城市</a-col>
          <a-col span="18">
            <a-cascader
              changeOnSelect
              :options="citys"
              v-model="params.city"
              :fieldNames="{ label: 'name', value: 'id', children: 'children' }"
              placeholder="请选择城市"
              style="display:block"
              @click="getCityData"
            >
              <a-icon slot="suffixIcon" :type="citys ? 'down' : 'loading'" />
            </a-cascader>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">工作年限</a-col>
          <a-col span="18">
            <a-select
              style="display:block"
              v-model="params.working_years"
              placeholder="请选择"
            >
              <a-select-option :value="1">1-3年</a-select-option>
              <a-select-option :value="2">3-5年</a-select-option>
              <a-select-option :value="3">5-10年</a-select-option>
              <a-select-option :value="4">10年以上</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-input-group compact>
          <a-select style="width:35%" v-model="params.hunter">
            <a-select-option value="hunter_name">猎头姓名</a-select-option>
            <a-select-option value="hunter_tel">猎头手机</a-select-option>
            <!-- <a-select-option value="hunter_email">猎头邮箱</a-select-option> -->
          </a-select>
          <a-input
            style="width:65%"
            v-model="params.hunterValue"
            placeholder="请输入关键字"
          ></a-input>
        </a-input-group>
      </a-col>
      <a-col span="8" style="margin-bottom:25px;">
        <a-row type="flex" align="middle" style="padding-top:5px">
          <a-col span="6" style="text-align:center">性别：</a-col>
          <a-col span="18">
            <a-radio-group v-model="params.gender_id">
              <template v-for="(value, key) in config.sex">
                <a-radio :key="key" :value="key">{{ value }}</a-radio>
              </template>
            </a-radio-group>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
          type="primary"
          style="margin-right:12px;padding:0 30px;"
          @click="getData()"
          >筛选</a-button
        >
        <a-button style="margin-right:12px;" @click="resetParams"
          >清空筛选条件</a-button
        >
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
      <a-col>
        <a-button type="primary" style>导出数据</a-button>
      </a-col>
    </a-row>

    <div class="data-table" style="padding:30px 0;">
      <a-table
        :columns="columns"
        :rowClassName="() => 'table-row'"
        :dataSource="dataSource"
        rowKey="id"
        :pagination="pagination"
        :loading="loading"
        @change="getData"
        :customRow="rowClick"
      >
        <template slot="count_posts" slot-scope="version_count">
          <a-button type="link">{{ version_count }}</a-button>
        </template>
      </a-table>
    </div>
    <a-drawer
      :visible="drawer"
      :closable="false"
      width="900"
      @close="drawer = !drawer"
      :destroyOnClose="true"
    >
      <a-row
        type="flex"
        justify="space-between"
        align="middle"
        style="paddingBottom:40px;"
      >
        <a-col style="cursor:pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }" />
        </a-col>
        <a-col style="cursor:pointer" @click="viewDetail">
          <a-icon type="fullscreen" />在新窗口打开
        </a-col>
      </a-row>
      <resume-detail :id="resume_id"></resume-detail>
    </a-drawer>
  </div>
</template>

<script>
import moment from "moment";
import Api from "@/api";
import ResumeDetail from "./resume-detail";
import { mapState } from "vuex";
export default {
  name: "Resume",
  data() {
    return {
      openPicker: false,
      loading: false,
      dataSource: [],
      columns: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true
      },
      options: [],
      params: {},
      drawer: false,
      resume_id: undefined,
      jobs: [],
      citys: []
    };
  },
  components: { ResumeDetail },
  computed: {
    ...mapState(["config"])
  },
  created() {
    this.resetParams();
    this.setColums();
    this.getData();
  },
  methods: {
    handleSelectPicker(dates) {
      let startDate = dates[0] && dates[0].format("YYYY-MM-DD");
      let endDate = dates[1] && dates[1].format("YYYY-MM-DD");
      if (this.params.uploadTime.length && startDate === endDate) {
        this.$message.warning("起止时间不能选择同一天");
        this.params.uploadTime = [];
      }
    },
    setColums() {
      this.columns = [
        {
          title: "姓名",
          dataIndex: "name"
        },
        {
          title: "性别",
          dataIndex: "gender_id",
          customRender: (text, record, index) => {
            return text == 1 ? "男" : text == 2 ? "女" : text == 3 ? "保密" : "未知";
          }
        },
        {
          title: "手机号",
          dataIndex: "mosaic_mobile"
        },
        {
          title: "工作年限",
          dataIndex: "working_years_name"
        },
        {
          title: "学历",
          dataIndex: "education_name"
        },
        {
          title: "所在城市",
          dataIndex: "city_name"
        },
        {
          title: "目前所在公司",
          dataIndex: "last_company"
        },
        {
          title: "目前年薪",
          dataIndex: "salary_total"
        },
        {
          align: "center",
          title: "简历版本数",
          dataIndex: "version_count",
          scopedSlots: { customRender: "count_posts" }
        }
      ];
    },
    async getData(pagination, filters, sorter) {
      this.loading = true;
      if (pagination) {
        let pager = { ...this.pagination };
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      } else {
        this.pagination.current = 1;
      }
      let params = {
        created_start:
          this.params.uploadTime[0] &&
          this.params.uploadTime[0].format("YYYY-MM-DD 00:00:00"),
        created_end:
          this.params.uploadTime[1] &&
          this.params.uploadTime[1].format("YYYY-MM-DD 00:00:00"),
        first_category_id: this.params.job[0],
        second_category_id: this.params.job[1],
        province_id: this.params.city[0],
        city_id: this.params.city[1],
        dist_id: this.params.city[2],
        education_id: this.params.education_id,
        [this.params.main]: this.params.mainValue,
        [this.params.hunter]: this.params.hunterValue,
        gender_id: this.params.gender_id,
        working_years: this.params.working_years,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      try {
        let response = await Api.resume.getList(params);
        this.pagination.total = +response.total;
        this.dataSource = response.list;
      } catch (e) {}
      this.loading = false;
    },
    resetParams() {
      let params = {
        uploadTime: [
          // moment()
          //   .startOf("day")
          //   .subtract(1, "days"),
          // moment().endOf("day")
        ],
        job: [],
        city: [],
        education_id: undefined,
        main: "resume_name",
        mainValue: "",
        working_years: undefined,
        hunter: "hunter_name",
        hunterValue: "",
        gender_id: ""
      };

      this.params = { ...params };
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;
            this.resume_id = record.id;
          }
        }
      };
    },
    viewDetail(record) {
      this.drawer = false;
      let resolvedRoute = this.$router.resolve({
        path: `detail/${this.resume_id}`
      });
      window.open(resolvedRoute.href, "_blank");
    },
    async getJobData() {
      this.jobs = undefined;
      let { tree: jobs } = await Api.common.getPostTree();
      this.jobs = jobs;
    },
    async getCityData() {
      this.citys = undefined;
      let { tree: citys } = await Api.common.getCityTree();
      this.citys = citys;
    }
  }
};
</script>

<style lang="scss">
.table-row {
  cursor: pointer;
}
</style>
